import { createSelector } from 'reselect';
import { CITY_MODES } from '@/constants';

export const isAuthenticated = (state) => state.user.isAuthenticated;
export const isPreAuthenticationPhase = (state) =>
  state.user.isPreAuthenticationPhase;
export const cityMode = (state) => state.user.cityMode;
export const currentCity = (state) => state.user.currentCity;
export const isAdmin = (state) => state.user.attributes.isAdmin;
export const contactEmailInFlight = (state) => state.user.contactEmailInFlight;
export const helpCenterEmailInFlight = (state) =>
  state.user.helpCenterEmailInFlight;
export const helpCenterEmailSuccessful = (state) =>
  state.user.helpCenterEmailSuccessful;
export const defaultCity = (state) => state.user.defaultCity;
export const groups = (state) => state.user.userRoles.groups;
export const username = (state) => state.user.attributes.username;

export const displayCitySelection = createSelector(
  isAdmin,
  (userIsAdmin) => userIsAdmin
);

export const showAll = (state) => state.user.showAll;

export const derivedCityMode = createSelector(
  cityMode,
  showAll,
  (cityModeValue, showAllValue) => {
    if (showAllValue) return CITY_MODES.customer;
    return cityModeValue;
  }
);

export const userFullName = (state) =>
  `${state.user.userFirstName} ${state.user.userLastName}`;

export const userRights = (state) => state.user.userRights;

// Unformatted data from retrieved from STR Oracle API "user_cities" endpoint
export const authorizedCities = (state) => state.user.authorizedCities;

/**
 * Data from this is an array of objects specifically formatted for
 *  RSuite's autocomplete/search functionality
 * e.g. [{ value: 'ca-kern' label: 'Kern County, CA' }]
 */
export const authorizedPlacesRsuite = createSelector(
  authorizedCities,
  (authCities) =>
    Object.keys(authCities).map((city) => ({
      value: authCities[city].place,
      label: city,
    }))
);

/**
 * Data from this is an array of strings, where each string is the hyphenated place string
 * e.g. ['ca-kern', 'ca-placer']
 */
export const authorizedPlacesList = createSelector(
  authorizedCities,
  (authCities) => Object.keys(authCities).map(({ place }) => place)
);
